import { wc } from 'utils/web-component';
import { App } from 'components/App';

// Standalone enforces access via SecureOutlet and must keep rendering its own error screen; gating it would blank that screen.
customElements.define('ex3d-app', wc(App, { gated: false }));
